module.exports = __webpack_public_path__ + "media/images/logo/fakturaonline-logo-nl-5219eefa273cd9833c70922fc0f5f838.svg";